module.exports = __webpack_public_path__ + "img/Inspirational Motivator.748c6c19.svg";